import {
  getCompanySettings,
  saveCompanySettings
} from "../../../services/CompanyService";
import {
  Box,
  Button,
  Checkbox,
  Chip,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography
} from "@mui/material";
import {useMessageContext} from "../../../contexts/MessageContext";
import {useEffect, useState} from "react";
import {Autocomplete} from "@mui/lab";
import {CompanyFeatureType} from "../../../enums/CompanyFeatureType";
import SaveIcon from '@mui/icons-material/Save';

const CompanySettingsTab = ({company, setLoader, setRefresh}) => {
  const {notificationHandler} = useMessageContext();

  const [reload, setReload] = useState(false);

  const [companySettings, setCompanySettings] = useState();

  useEffect(() => {
    setLoader(true);
    getCompanySettings(company.id)
        .then(res => setCompanySettings(res.data))
        .finally(() => setLoader(false))
  }, [reload, company.id, setLoader]);

  const updateBrandArchetype = (brandArchetype) => {
    setCompanySettings(prv => {
      return {...prv, brandArchetype}
    })
  }

  const updateAgentRole = (agentRole) => {
    setCompanySettings(prv => {
      return {...prv, agentRole}
    })
  }

  const updateCorporateFonts = (fonts) => {
    setCompanySettings(prv => {
      return {...prv, fonts}
    })
  }

  const updateCorporateColors = (colors) => {
    setCompanySettings(prv => {
      return {...prv, colors}
    })
  }

  const updateIndustryPublication = (industryPublication) => {
    setCompanySettings(prv => {
      return {...prv, industryPublication}
    })
  }

  const updateNewsQuery = (newsQuery) => {
    setCompanySettings(prv => {
      return {...prv, newsQuery}
    })
  }

  const updateX = (x) => {
    setCompanySettings(prv => {
      let bannerDefaults = {...prv.bannerDefaults};
      bannerDefaults["x"] = x;
      return {...prv, bannerDefaults}
    })
  }

  const updateY = (y) => {
    setCompanySettings(prv => {
      let bannerDefaults = {...prv.bannerDefaults};
      bannerDefaults["y"] = y;
      return {...prv, bannerDefaults}
    })
  }

  const updateMaxWidth = (maxWidth) => {
    setCompanySettings(prv => {
      let bannerDefaults = {...prv.bannerDefaults};
      bannerDefaults["maxWidth"] = maxWidth;
      return {...prv, bannerDefaults}
    })
  }

  const updateMaxHeight = (maxHeight) => {
    setCompanySettings(prv => {
      let bannerDefaults = {...prv.bannerDefaults};
      bannerDefaults["maxHeight"] = maxHeight;
      return {...prv, bannerDefaults}
    })
  }

  const updateFontSize = (fontSize) => {
    setCompanySettings(prv => {
      let bannerDefaults = {...prv.bannerDefaults};
      bannerDefaults["fontSize"] = fontSize;
      return {...prv, bannerDefaults}
    })
  }

  const updateColor = (color) => {
    setCompanySettings(prv => {
      let bannerDefaults = {...prv.bannerDefaults};
      bannerDefaults["color"] = color;
      return {...prv, bannerDefaults}
    })
  }

  const updateArticleX = (x) => {
    setCompanySettings(prv => {
      let articleDefaults = {...prv.articleDefaults};
      articleDefaults["x"] = x;
      return {...prv, articleDefaults}
    })
  }

  const updateArticleY = (y) => {
    setCompanySettings(prv => {
      let articleDefaults = {...prv.articleDefaults};
      articleDefaults["y"] = y;
      return {...prv, articleDefaults}
    })
  }

  const updateArticleMaxWidth = (maxWidth) => {
    setCompanySettings(prv => {
      let articleDefaults = {...prv.articleDefaults};
      articleDefaults["maxWidth"] = maxWidth;
      return {...prv, articleDefaults}
    })
  }

  const updateArticleMaxHeight = (maxHeight) => {
    setCompanySettings(prv => {
      let articleDefaults = {...prv.articleDefaults};
      articleDefaults["maxHeight"] = maxHeight;
      return {...prv, articleDefaults}
    })
  }

  const updateArticleFontSize = (fontSize) => {
    setCompanySettings(prv => {
      let articleDefaults = {...prv.articleDefaults};
      articleDefaults["fontSize"] = fontSize;
      return {...prv, articleDefaults}
    })
  }

  const updateArticleFont = (font) => {
    setCompanySettings(prv => {
      let articleDefaults = {...prv.articleDefaults};
      articleDefaults["font"] = font;
      return {...prv, articleDefaults}})
  }

  const updateBannerFont = (font) => {
    setCompanySettings(prv => {
      let bannerDefaults = {...prv.bannerDefaults};
      bannerDefaults["font"] = font;
      return {...prv, bannerDefaults}})
  }

  const updateArticleColor = (color) => {
    setCompanySettings(prv => {
      let articleDefaults = {...prv.articleDefaults};
      articleDefaults["color"] = color;
      return {...prv, articleDefaults}
    })
  }

  const updateFeature = (feature) => {
    setCompanySettings(prv => {
      let enabledFeatures = [...prv.enabledFeatures];
      if (enabledFeatures.includes(feature)) {
        enabledFeatures = enabledFeatures.filter(f => f !== feature);
      } else {
        enabledFeatures.push(feature);
      }
      return {...prv, enabledFeatures}
    });
  }

  const fonts = [
    "Inter-Bold", "Inter-Regular",
    "Helvetica-Bold", "Helvetica-Regular",
    "Lato-Bold", "Lato-Regular",
    "Montserrat-Bold", "Montserrat-Regular",
    "OpenSans-Bold", "OpenSans-Regular",
    "Poppins-Bold", "Poppins-Regular",
    "Roboto-Bold", "Roboto-Regular",
    "SourceSerif4-Bold", "SourceSerif4-Regular",
    "Ubuntu-Bold", "Ubuntu-Regular",
    "Manrope-Bold", "Manrope-Regular",
    "NotoSans-Bold", "NotoSans-Regular",
  ];

  const brandArchetypes = [
    { value: "THE_CAREGIVER", name: "The Caregiver", description: "Compassionate, nurturing, selfless, supportive" },
    { value: "THE_RULER", name: "The Ruler", description: "Authoritative, organized, responsible, decisive" },
    { value: "THE_CREATOR", name: "The Creator", description: "Innovative, imaginative, artistic, visionary" },
    { value: "THE_INNOCENT", name: "The Innocent", description: "Pure, optimistic, simple, honest" },
    { value: "THE_SAGE", name: "The Sage", description: "Wise, knowledgeable, analytical, insightful" },
    { value: "THE_EXPLORER", name: "The Explorer", description: "Adventurous, independent, ambitious, freedom-seeking" },
    { value: "THE_REBEL", name: "The Rebel", description: "Revolutionary, nonconformist, daring" },
    { value: "THE_MAGICIAN", name: "The Magician", description: "Visionary, imaginative, transformative, charismatic" },
    { value: "THE_HERO", name: "The Hero", description: "Courageous, strong, determined, triumphant" },
    { value: "THE_LOVER", name: "The Lover", description: "Passionate, sensual, romantic, committed" },
    { value: "THE_JESTER", name: "The Jester", description: "Playful, humorous, irreverent, carefree" },
    { value: "THE_REGULAR_GUY", name: "The Regular Guy/Girl", description: "Down-to-earth, relatable, genuine, friendly" }
  ];

  return (
    <Paper
      component="form"
      onSubmit={(event => {
        event.preventDefault();
        setLoader(true);
        let body = {...companySettings}
        body["companyId"] = company.id;
        saveCompanySettings(body)
            .then(() => setRefresh(prv => !prv))
            .then(() => notificationHandler.success('Company Settings Saved'))
            .finally(() => setLoader(false))
      })}
      sx={{ mt: 3, p: 3 }}
      elevation={1}
    >
      {companySettings && (
        <Box>
          {/* Brand Settings */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Brand Settings
          </Typography>

          <FormControl fullWidth size="small" sx={{ mb: 2 }}>
            <InputLabel>Brand Archetype</InputLabel>
            <Select
                label="Brand Archetype"
                value={companySettings.brandArchetype || ""}
                onChange={(e) => updateBrandArchetype(e.target.value)}
            >
              {brandArchetypes.map((archetype, i) => (
                <MenuItem key={i} value={archetype.value}>
                  <Box>
                    <Typography sx={{ fontSize: "0.875rem", fontWeight: 600 }}>{archetype.name}</Typography>
                    <Typography sx={{ fontSize: "0.75rem", color: "text.secondary" }}>{archetype.description}</Typography>
                  </Box>
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
              fullWidth
              size="small"
              multiline
              minRows={3}
              id="agentRole"
              name="agentRole"
              label="Agent Role"
              placeholder="Describe the agent role..."
              variant="outlined"
              onChange={e => updateAgentRole(e.target.value)}
              value={companySettings?.agentRole || ""}
              sx={{ mb: 2 }}
          />

          <Divider sx={{ my: 3 }} />

          {/* Corporate Identity */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Corporate Identity
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <Autocomplete
                multiple
                size="small"
                id="corporate-fonts"
                sx={{ flex: 1 }}
                options={[]}
                freeSolo
                value={companySettings?.fonts || []}
                onChange={(event, newValue) => {
                  updateCorporateFonts(newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return <Chip key={key} size="small" variant="filled" label={option} {...tagProps} />;
                    })
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Corporate Fonts" placeholder="Add font..." />
                )}
            />
            <Autocomplete
                multiple
                size="small"
                id="corporate-colors"
                sx={{ flex: 1 }}
                options={[]}
                freeSolo
                value={companySettings?.colors || []}
                onChange={(event, newValue) => {
                  updateCorporateColors(newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return <Chip key={key} size="small" variant="filled" label={option} {...tagProps} />;
                    })
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Corporate Colors" placeholder="Add color..." />
                )}
            />
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* News Settings */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            News Settings
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <Autocomplete
                multiple
                size="small"
                id="industry-publication"
                sx={{ flex: 1 }}
                options={[]}
                freeSolo
                value={companySettings?.industryPublication || []}
                onChange={(event, newValue) => {
                  updateIndustryPublication(newValue);
                }}
                renderTags={(value, getTagProps) =>
                    value.map((option, index) => {
                        const { key, ...tagProps } = getTagProps({ index });
                        return <Chip key={key} size="small" variant="filled" label={option} {...tagProps} />;
                    })
                }
                renderInput={(params) => (
                    <TextField {...params} variant="outlined" label="Industry Publication" placeholder="Add publication..." />
                )}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                multiline
                minRows={2}
                id="newsQuery"
                name="newsQuery"
                label="News Query"
                placeholder="Enter news query..."
                variant="outlined"
                onChange={e => updateNewsQuery(e.target.value)}
                value={companySettings?.newsQuery || ""}
            />
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Banner Defaults */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Banner Defaults
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="bannerFontSize"
                name="fontSize"
                label="Font Size"
                type="number"
                variant="outlined"
                onChange={(e) => updateFontSize(e.target.value)}
                value={companySettings?.bannerDefaults?.fontSize || ""}
            />
            <FormControl size="small" sx={{ flex: 1 }}>
              <InputLabel>Font</InputLabel>
              <Select
                  label="Font"
                  value={companySettings?.bannerDefaults?.font || ""}
                  onChange={(e) => updateBannerFont(e.target.value)}
              >
                {fonts.map((font, i) => (
                  <MenuItem key={i} value={font}>{font}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="bannerColor"
                name="color"
                label="Font Color"
                type="text"
                variant="outlined"
                onChange={(e) => updateColor(e.target.value)}
                value={companySettings?.bannerDefaults?.color || ""}
            />
          </Box>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="bannerX"
                name="x"
                label="X Position"
                type="number"
                variant="outlined"
                onChange={(e) => updateX(e.target.value)}
                value={companySettings?.bannerDefaults?.x || ""}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="bannerY"
                name="y"
                label="Y Position"
                type="number"
                variant="outlined"
                onChange={(e) => updateY(e.target.value)}
                value={companySettings.bannerDefaults?.y || ""}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="bannerMaxWidth"
                name="maxWidth"
                label="Max Width"
                type="number"
                variant="outlined"
                onChange={(e) => updateMaxWidth(e.target.value)}
                value={companySettings.bannerDefaults?.maxWidth || ""}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="bannerMaxHeight"
                name="maxHeight"
                label="Max Height"
                type="number"
                variant="outlined"
                onChange={(e) => updateMaxHeight(e.target.value)}
                value={companySettings.bannerDefaults?.maxHeight || ""}
            />
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Article Defaults */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Article Image Defaults
          </Typography>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="articleFontSize"
                name="fontSize"
                label="Font Size"
                type="number"
                variant="outlined"
                onChange={(e) => updateArticleFontSize(e.target.value)}
                value={companySettings?.articleDefaults?.fontSize || ""}
            />
            <FormControl size="small" sx={{ flex: 1 }}>
              <InputLabel>Font</InputLabel>
              <Select
                  label="Font"
                  value={companySettings?.articleDefaults?.font || ""}
                  onChange={(e) => updateArticleFont(e.target.value)}
              >
                {fonts.map((font, i) => (
                  <MenuItem key={i} value={font}>{font}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="articleColor"
                name="color"
                label="Font Color"
                type="text"
                variant="outlined"
                onChange={(e) => updateArticleColor(e.target.value)}
                value={companySettings?.articleDefaults?.color || ""}
            />
          </Box>

          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="articleX"
                name="x"
                label="X Position"
                type="number"
                variant="outlined"
                onChange={(e) => updateArticleX(e.target.value)}
                value={companySettings?.articleDefaults?.x || ""}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="articleY"
                name="y"
                label="Y Position"
                type="number"
                variant="outlined"
                onChange={(e) => updateArticleY(e.target.value)}
                value={companySettings.articleDefaults?.y || ""}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="articleMaxWidth"
                name="maxWidth"
                label="Max Width"
                type="number"
                variant="outlined"
                onChange={(e) => updateArticleMaxWidth(e.target.value)}
                value={companySettings.articleDefaults?.maxWidth || ""}
            />
            <TextField
                size="small"
                sx={{ flex: 1 }}
                id="articleMaxHeight"
                name="maxHeight"
                label="Max Height"
                type="number"
                variant="outlined"
                onChange={(e) => updateArticleMaxHeight(e.target.value)}
                value={companySettings.articleDefaults?.maxHeight || ""}
            />
          </Box>

          <Divider sx={{ my: 3 }} />

          {/* Features */}
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 2, fontWeight: 600, fontSize: "0.75rem", textTransform: "uppercase" }}>
            Automatic Publish Features
          </Typography>

          <FormGroup sx={{ display: "flex", flexDirection: "row", flexWrap: "wrap", gap: 1 }}>
            {Object.keys(CompanyFeatureType).map((feature, i) => (
              <FormControlLabel
                key={i}
                control={
                  <Checkbox
                    size="small"
                    checked={companySettings.enabledFeatures?.some(key => key === feature)}
                    onChange={() => updateFeature(feature)}
                  />
                }
                label={<Typography variant="body2">{CompanyFeatureType[feature]}</Typography>}
              />
            ))}
          </FormGroup>

          <Divider sx={{ my: 3 }} />

          {/* Actions */}
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="submit"
              variant="contained"
              startIcon={<SaveIcon />}
            >
              Save Changes
            </Button>
          </Box>
        </Box>
      )}
    </Paper>
  );
};

export default CompanySettingsTab;
